export default class dataRequest {
  constructor(service) {
    this.service = service;
  }

  getData$() {
    return this.service
      .fetch$({
        method: 'GET',
        url: '/data',
      });
  }

  getGroupItemData$(groupId) {
    return this.service
      .fetch$({
        method: 'GET',
        url: `/data?groupId=${groupId}`,
      });
  }

  setNotificationRead$(id) {
    return this.service
      .fetch$({
        method: 'PUT',
        url: `/data/read/${id}`,
      });
  }

  getHistoryData$(date, did, dataField) {
    return this.service
      .fetch$({
        method: 'GET',
        timeout: 10000,
        url: `/data/history?date=${date}&did=${did}&dataField=${dataField}`,
      });
  }
}
